import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  blue9,
  green8,
  grey8,
  grey10,
  orange9,
} from 'approot/shared/styles/colours.style';
import {
  font14,
  fontWeightMedium,
  PStyled,
} from 'approot/shared/styles/typography.style';
import { spacing4, spacing16 } from 'approot/shared/styles/spacing.style';
import { DropdownToggle } from 'approot/shared/dropdown/dropdown.style';
import { DropdownItemFlex } from 'approot/shared/dropdown/dropdown-item.style';
import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';

export const DifferentiationDropdownItem = styled(DropdownItemFlex)`
  align-items: flex-start;
`;

export const DifferentiationDropdownToggle = styled(DropdownToggle)``;

export const DifferentiationDropdownItemBox = styled.div`
  margin-right: ${rem(spacing16)};
  padding-top: ${rem(spacing4)};
`;

type DifferentiationDropdownItemDescriptionProps = {
  $differentiation: Differentiation;
};

export const DifferentiationDropdownItemTitle = styled(PStyled).attrs({
  colour: grey8,
  marginBottom: 0,
})<DifferentiationDropdownItemDescriptionProps>`
  ${font14}

  font-weight: ${fontWeightMedium};
  color: ${({ $differentiation }) =>
    $differentiation === Differentiation.GreenCircle
      ? green8
      : $differentiation === Differentiation.BlueSquare
        ? blue9
        : $differentiation === Differentiation.OrangeCross
          ? orange9
          : grey10};
`;

export const DifferentiationDropdownItemDescription = styled(PStyled).attrs({
  colour: grey8,
  marginBottom: 0,
})<DifferentiationDropdownItemDescriptionProps>`
  ${font14}
`;
